import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investing',
  templateUrl: './investing.component.html',
  styleUrls: ['./investing.component.css']
})
export class InvestingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
